export default defineNuxtPlugin((nuxtApp) => {
  const shouldSkipMixpanel = (() => {
    try {
      const search = globalThis.location.search;
      if (!search) {
        return false;
      }

      return new URLSearchParams(search).get('mixmin') === '1';
    } catch {
      return false;
    }
  })();

  nuxtApp.hook('app:created', () => {
    try {
      const startMs = Number(sessionStorage.getItem('appStartPerfNow'));
      if (!shouldSkipMixpanel && Number.isFinite(startMs) && startMs > 0) {
        const mixpanel = (window as any).mixpanel;
        const posthog = usePostHog();
        mixpanel?.track?.('Bundle Downloaded', {
          bundle_download_ms: Math.round(performance.now() - startMs),
        });
        posthog?.capture('Bundle Downloaded', { bundle_download_ms: Math.round(performance.now() - startMs) });
      }
    } catch {
      void 0;
    }
  });

  function removeOverlay() {
    delete document.documentElement.dataset.startTap;

    const overlay = document.getElementById('age-overlay');
    if (overlay) {
      overlay.classList.add('ao-hide');
      setTimeout(() => {
        overlay.remove();
        document.getElementById('ao-styles')?.remove();
      }, 400);
    }

    try {
      sessionStorage.setItem('aoLoaderFlowComplete', '1');
    } catch {
      void 0;
    }

    try {
      const startMs = Number(sessionStorage.getItem('appStartPerfNow'));
      if (!shouldSkipMixpanel && Number.isFinite(startMs) && startMs > 0) {
        const mixpanel = (window as any).mixpanel;
        const posthog = usePostHog();
        mixpanel?.track?.('WebApp Started', {
          webapp_start_ms: Math.round(performance.now() - startMs),
        });
        posthog?.capture('WebApp Started', { webapp_start_ms: Math.round(performance.now() - startMs) });
      }
    } catch {
      void 0;
    }
  }

  return {
    provide: {
      closeLoader: removeOverlay,
    },
  };
});
